import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import type { VisibilityLevel } from '@core/visibility-types';

@Injectable()
export class VisibilitySelectorAnalytics extends AnalyticsBase {
  public namespace = 'Visibility';
  public requireViewContext = true;

  public trackDropdownOpen() {
    this.track('DropdownOpen');
  }

  public trackChange(params: { level: VisibilityLevel; selectedMembersCount: number }) {
    this.track('Change', params);
  }
}
